
import { apiClienteGenerica } from "../../apis";
import Swal from "sweetalert2";



export const startComprarOPCliente = async( datos ) => {
    try {
        const formData = new FormData();
        if(datos?.imgPago && typeof datos?.imgPago !== 'string') { formData.append('images', datos.imgPago); }
        Object.entries(datos).forEach(([key, value]) => { formData.append(key, value?.toString()); });

        const { data } = await apiClienteGenerica.post('op/new/cliente', formData);
        Swal.fire(  
            `Tu Op es: ${ data.data.op }`, 
            `Se inicia con <strong>50% de anticipo</strong> y el saldo contra entrega; 
            <strong>no hay devoluciones</strong> ni reclamaciones después de <strong>30 días</strong>. 
            Las correcciones se reciben solo hasta el día siguiente de la entrega.
            </p>

            <p>
            El cliente debe <strong>aprobar el diseño antes de imprimir</strong>; 
            no respondemos por errores tras la aprobación. 
            Los <strong>colores y tamaños pueden variar</strong>. 
            Entregas urgentes o a domicilio tienen <strong>costo adicional</strong>.`, 
            'success'
        );
        return true;

    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
} 
